import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'

import en from '../locale/en'
import sv from '../locale/sv'
import fi from '../locale/en'

import EnglishFlag from "@/components/lang/EnglishFlag.vue";
import SwedishFlag from "@/components/lang/SwedishFlag.vue";
import FinnishFlag from "@/components/lang/FinnishFlag.vue";

const supportedLocales = ['en', 'sv']

const browserLang = navigator.language.substring(0, 2);

const darkTheme = localStorage.getItem('theme.dark') === 'true'

const vuetifyOpts = {
  theme: {
    dark: !!darkTheme,
    themes: {
      light: {
        primary: "#558930",
        secondary: "#8BB640",
        accent: "#449AD4",
        error: "#E94B4B",
        info: "#5FBDEB",
        success: "#43A047",
        warning: "#E69D3D",
      },
      dark: {
        primary: "#34541E",
        secondary: "#617F2D",
        accent: "#295D7F",
        error: "#C03E40",
        info: "#52A3CB",
        success: "#4A9A37",
        warning: "#CC8B36",
      },
    },
  },
  lang: {
    locales: { en, sv, fi },
    current: supportedLocales.includes(browserLang) ? browserLang : 'en',
  },
  breakpoint: {
    mobileBreakpoint: "sm", // This is equivalent to a value of 960
  },
  icons: {
    iconfont: "mdi",
    values: {
      add: "mdi-plus",
      address: "mdi-email",
      alert: "mdi-alert",
      back: "mdi-chevron-double-left",
      bank: "mdi-bank",
      bell: "mdi-bell",
      bubble: "mdi-chart-bubble",
      calendar: "mdi-calendar",
      camera: "mdi-camera",
      cancel: "mdi-close",
      car: "mdi-car",
      check: "mdi-check-circle-outline",
      close: "mdi-close",
      cloud: "mdi-cloud",
      cog: "mdi-cog",
      comment: "mdi-chat-outline",
      company: "mdi-factory",
      content: "mdi-file-outline",
      contract: "mdi-file-document-edit-outline",
      delete: "mdi-delete",
      download: "mdi-cloud-download-outline",
      dropdown: "mdi-menu-down",
      edit: "mdi-pencil-outline",
      email: "mdi-at",
      eye: "mdi-eye",
      facebook: "mdi-facebook",
      favorite: "mdi-star",
      file: "mdi-file-cabinet",
      followup: "mdi-chart-line",
      group: "mdi-account-multiple",
      heart: "mdi-heart",
      help: "mdi-help-circle",
      home: "mdi-home",
      info: "mdi-information-outline",
      instagram: "mdi-instagram",
      internet: "mdi-web",
      key: "mdi-key",
      lightbulb: "mdi-lightbulb",
      linkedin: "mdi-linkedin",
      list: "mdi-format-list-bulleted",
      lock: "mdi-lock",
      logout: "mdi-logout-variant",
      magnify: "mdi-magnify",
      mail: "mdi-email",
      map: "mdi-map-marker",
      menu: "mdi-dots-vertical",
      money: "mdi-currency-eur",
      mushroom: "mdi-mushroom",
      ok: "mdi-check",
      person: "mdi-account",
      phone: "mdi-phone",
      print: "mdi-printer",
      radioactive: "mdi-radioactive",
      reload: "mdi-refresh",
      reminder: "mdi-alarm",
      save: "mdi-content-save",
      search: "mdi-magnify",
      send: "mdi-send",
      sequence: "mdi-numeric",
      share: "mdi-share",
      sign: "mdi-draw-pen",
      social: "mdi-web",
      tree: "mdi-pine-tree",
      twitter: "mdi-twitter",
      upload: "mdi-cloud-upload-outline",
      user: "mdi-account",
      view: "mdi-eye",
      water: "mdi-water",
      workflow: "mdi-animation-play-outline",
      www: "mdi-web",

      english: {
        component: EnglishFlag,
      },
      swedish: {
        component: SwedishFlag,
      },
      finnish: {
        component: FinnishFlag,
      },
    },
  },
};

Vue.use(Vuetify)

export default new Vuetify(vuetifyOpts)
